// frontend/src/components/ui/FilterBar.tsx
// Container for filter controls above a list/table.
// Matches proto `.filterbar` / `.fgroup` / `.glabel` classes.
// Presentational only — no data fetching, no mutations.

import type { ReactNode } from "react";
import { cn } from "../../lib/cn";

// ─── FilterBar ────────────────────────────────────────────────────────────────

export interface FilterBarProps {
  children: ReactNode;
  className?: string;
}

export function FilterBar({ children, className }: FilterBarProps): JSX.Element {
  return (
    <div
      className={cn(
        // Proto .filterbar
        "flex items-end gap-3 flex-wrap",
        "bg-surface border border-border rounded-[11px] p-[11px_13px] shadow-card",
        "mb-4",
        className,
      )}
    >
      {children}
    </div>
  );
}

// ─── FilterGroup ──────────────────────────────────────────────────────────────
// Sub-component: renders a label above a filter control.

export interface FilterGroupProps {
  /** Short label shown in uppercase above the control */
  label: string;
  children: ReactNode;
  className?: string;
}

export function FilterGroup({ label, children, className }: FilterGroupProps): JSX.Element {
  return (
    <div className={cn("flex flex-col gap-[5px]", className)}>
      {/* Proto .fgroup .glabel */}
      <span className="text-[10px] font-bold tracking-[.05em] uppercase text-dim">
        {label}
      </span>
      {children}
    </div>
  );
}
